import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from 'rehype-raw';


const PreviewModal = ({ file, onClose, path }) => {
  const { name } = file;
  const ext = name.split(".").pop().toLowerCase();
 
  const url = "/documents"+ path + "/" + name;
 
  const [content, setContent] = useState("");
 
  // fetch konten jika markdown
  useEffect(() => {
    if (["md", "markdown"].includes(ext)) {
      fetch(url+"?t="+Date.now(), { cache: "no-store" }) 
        .then((res) => res.text())
        .then(setContent)
        .catch(() => setContent("⚠️ Failed to load markdown content"));
    }
  }, [url, ext]);

  return (
    <div style={modalOverlayStyle}>
      <div style={modalContentStyle}>
        <button onClick={onClose} style={closeButtonStyle}>✖</button>
        <br/>
        <h4>{name}</h4>

        {["jpg", "jpeg", "png", "gif", "webp"].includes(ext) && (
          <img
            src={url}
            alt={name}
            style={{ width: "100%", borderRadius: 8 }}
          />
        )}

        {["pdf"].includes(ext) && (
          <iframe
            src={url}
            title={name}
            width="100%"
            height="600px"
            style={{ border: "none" }}
          />
        )}

        {["md", "markdown"].includes(ext) && (
          <div style={{ textAlign: "left" }}>
            <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{content}</ReactMarkdown>
          </div>
        )}

        {!["jpg", "jpeg", "png", "gif", "webp", "pdf", "md", "markdown"].includes(ext) && (
          <p>Preview not available for this file type.</p>
        )}
      </div>
    </div>
  );
};

// ---- Styles ----
const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 2000, // 🔥 pastikan lebih besar dari AppBar
};

const modalContentStyle = {
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "10px",
  width: "80%",
  maxWidth: "900px",
  maxHeight: "90vh",
  overflowY: "auto",
  position: "relative",
  boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
  marginTop: "50px",
};

const closeButtonStyle = {
  position: "absolute",
  top: 10,
  right: 10,
  background: "black",
  border: "none",
  fontSize: "18px",
  cursor: "pointer",
};

export default PreviewModal;
